import { render, staticRenderFns } from "./searchresult.html?vue&type=template&id=abb96638&scoped=true&"
import script from "./searchresult.js?vue&type=script&lang=js&"
export * from "./searchresult.js?vue&type=script&lang=js&"
import style0 from "./searchresult.css?vue&type=style&index=0&id=abb96638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb96638",
  null
  
)

export default component.exports